var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input-switch"},[_c('input',_vm._g(_vm._b({attrs:{"id":_vm.id,"type":"checkbox"}},'input',_vm.$attrs,false),_vm.$listeners)),_c('label',{attrs:{"for":_vm.id}},[_vm._m(0),_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"switch"},[_c('div',{staticClass:"inner"})])
}]

export { render, staticRenderFns }